/* tslint:disable */

declare var Object: any;
export interface LeaderBoardInterface {
  "id"?: number;
}

export class LeaderBoard implements LeaderBoardInterface {
  "id": number;
  constructor(data?: LeaderBoardInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LeaderBoard`.
   */
  public static getModelName() {
    return "LeaderBoard";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LeaderBoard for dynamic purposes.
  **/
  public static factory(data: LeaderBoardInterface): LeaderBoard{
    return new LeaderBoard(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LeaderBoard',
      plural: 'LeaderBoards',
      path: 'LeaderBoards',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/LeaderBoard.ts